export default __webpack_public_path__ + "static/media/razer-bg@2x.928105d1.webp";